import { Container, Sprite, Texture, Point } from 'pixi.js';

const slip = function (cml) { cml.baseMoveTime += (1 / this.totalTime) * this.time; };

export class Effect {
    static type = {
        slip: 'SLIP'
    };

    static effectFuncs = new Map([
        [Effect.type.slip, slip]
    ]);

    /**
     * An effect that applies a condition.
     * @param {number} totalTime time in fps that the effect lasts
     * @param {string} effectName
     */
    constructor(totalTime, effectName) {
        this.totalTime = totalTime;
        this.time = this.totalTime;

        if (Effect.effectFuncs.has(effectName)) this.effectFunc = Effect.effectFuncs.get(effectName);
        else this.effectFunc = Effect.effectFuncs.get(Effect.type.slip);
    }

    applyEffect(cml) {
        this.effectFunc.call(this, cml);
    }
}



export class Obstacle extends Container {


    constructor(id, textureId, effectName, tileX, tileY) {
        super();

        this.id = id;
        this.tilePos = new Point(tileX, tileY);
        this.isAnim = false;

        this.sprite = new Sprite.from(Texture.from(textureId) || Texture.EMPTY);
        this.sprite.anchor.set(0.5, 1);
        this.addChild(this.sprite);

        this.effect = new Effect(240, effectName);
    }

    setOffset(offset) {
        this.sprite.position.copyFrom(offset);
    }

    setDestroyCB(cb) {
        this.destroyCB = cb;
    }

    destroy() {
        if (this.destroyCB) this.destroyCB();
    }
}
